<template>
  <b-modal
    id="change-password-modal"
    ref="modal"
    :title="$t('user.Password')"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
    :ok-title="$t('Validate')"
    :cancel-title="$t('Cancel')"
    cancel-variant="danger">

    <form ref="form" @submit.stop.prevent="handleSubmit">

      <!-- Old password -->
      <b-form-group
        :label="$t('OldPassword') + ' *'"
        label-for="oldPassword-input"
        :invalid-feedback="oldPassword.invalidFeedback"
        :state="oldPassword.state">
        <div class="login-password-container">
          <b-form-input
            id="oldPassword-input"
            class="password-input-with-an-eye"
            v-model="oldPassword.value"
            :state="oldPassword.state"
            :type="showOldPassword ? 'text' : 'password'"
            autocomplete="off"
            required
            @update="removeInvalidFeedback('oldPassword')">
          </b-form-input>
          <div class="login-show-password-btn" @click="showOldPassword = !showOldPassword">
            <i class="login-eye-btn ph-custom ph-eye-fill"/>
          </div>
        </div>
      </b-form-group>

      <!-- New password -->
      <b-form-group
        :label="$t('NewPassword') + ' *'"
        label-for="newPassword-input"
        :invalid-feedback="newPassword.invalidFeedback"
        :state="newPassword.state">
        <div class="login-password-container">
          <b-form-input
            id="newPassword-input"
            class="password-input-with-an-eye"
            v-model="newPassword.value"
            :state="newPassword.state"
            :type="showNewPassword ? 'text' : 'password'"
            autocomplete="off"
            required
            @update="removeInvalidFeedback('newPassword')">
          </b-form-input>
          <div class="login-show-password-btn" @click="showNewPassword = !showNewPassword">
            <i class="login-eye-btn ph-custom ph-eye-fill"/>
          </div>
        </div>
      </b-form-group>

      <!-- New password repeat -->
      <b-form-group
        :label="$t('NewPassword.confirm') + ' *'"
        label-for="newPasswordRepeat-input"
        :invalid-feedback="newPasswordRepeat.invalidFeedback"
        :state="newPasswordRepeat.state">
        <div class="login-password-container">
          <b-form-input
            id="newPasswordRepeat-input"
            class="password-input-with-an-eye"
            v-model="newPasswordRepeat.value"
            :state="newPasswordRepeat.state"
            :type="showNewPasswordRepeat ? 'text' : 'password'"
            autocomplete="off"
            required
            @update="removeInvalidFeedback('newPasswordRepeat')">
          </b-form-input>
          <div class="login-show-password-btn" @click="showNewPasswordRepeat = !showNewPasswordRepeat">
            <i class="login-eye-btn ph-custom ph-eye-fill"/>
          </div>
        </div>
      </b-form-group>

    </form>
  </b-modal>
</template>

<script>
import api from '../../services/api'
import {mapActions} from 'vuex'

export default {

  name: 'change-password-modal',

  data: function () {
    return {
      showOldPassword: false,
      showNewPassword: false,
      showNewPasswordRepeat: false,
      oldPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },
      newPassword: {
        value: null,
        state: null,
        invalidFeedback: null
      },
      newPasswordRepeat: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    }
  },

  methods: {

    ...mapActions(['LogIn']),

    resetModal() {
      this.oldPassword.value = null
      this.oldPassword.state = null
      this.oldPassword.invalidFeedback = null
      this.newPassword.value = null
      this.newPassword.state = null
      this.newPassword.invalidFeedback = null
      this.newPasswordRepeat.value = null
      this.newPasswordRepeat.state = null
      this.newPasswordRepeat.invalidFeedback = null
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      if (!this.isFormValid()) {
        return
      }

      let formData = new FormData()
      formData.append('oldPassword', this.oldPassword.value.trim())
      formData.append('newPassword', this.newPassword.value.trim())
      formData.append('newPasswordRepeat', this.newPasswordRepeat.value.trim())

      api({
        method: 'POST',
        url: `/user/updateCurrentUserPassword`,
        data: formData
      })
        .then(() => {
          let data = {
            username: this.$store.getters.username,
            password: this.newPassword.value.trim()
          }

          this.LogIn(data)

          this.resetModal()
          this.hideModal()
          this.successToast()
        })
        .catch(() => {
          this.errorToast()
        })
    },

    hideModal() {
      this.$bvModal.hide('change-password-modal')
    },

    isFormValid() {
      let valid = this.$refs.form.checkValidity()
      if (!valid) {
        this.$refs.form.reportValidity()
        return false
      }
      if (this.oldPassword.value == null || this.oldPassword.value.trim() === '') {
        this.oldPassword.state = false
        this.oldPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      }
      if (this.newPassword.value == null || this.newPassword.value.trim() === '') {
        this.newPassword.state = false
        this.newPassword.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.newPassword.value.trim().length < 8) {
        this.newPassword.state = false
        this.newPassword.invalidFeedback = this.$i18n.t('Password.minlenght.error')
        return false
      } else if (this.newPasswordRepeat.value == null || this.newPasswordRepeat.value.trim() === '') {
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = this.$i18n.t('MandatoryField')
        return false
      } else if (this.newPassword.value !== this.newPasswordRepeat.value) {
        this.newPasswordRepeat.state = false
        this.newPasswordRepeat.invalidFeedback = this.$i18n.t('NewPassword.not.corresponding')
        return false
      }
      return true
    },

    removeInvalidFeedback(field) {
      this[field]['state'] = null
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('ChangePassword.success'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    errorToast() {
      this.oldPassword.state = false
      this.oldPassword.invalidFeedback = this.$i18n.t('incorrect.password')
      this.$bvToast.toast(this.$i18n.t('password.error'), {
        title: this.$i18n.t('Error.title'),
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/ChangePasswordModal.vue